import { Component, inject } from '@angular/core';
import { RuntimeConfigService } from '../runtime-config.service';

@Component({
  selector: 'app-context',
  host: { ngSkipHydration: 'true' },
  template: `
    @if (showEnvironmentIndicator) {
      <div
        data-test-id="environment-indicator"
        class="absolute top-0 right-0 left-0 h-[2px] opacity-50"
        [style.backgroundColor]="backgroundColor"
      ></div>
    }
    <div
      class="pointer-events-none absolute right-1 bottom-1 text-[11px] select-none"
      [style.opacity]="showEnvironmentIndicator ? '0.3' : '0'"
    >
      {{ BUILD_ID }}.{{ SOURCE_VERSION }} ({{ ENVIRONMENT_KEY }})
    </div>
  `,
})
export class AppContextComponent {
  private readonly runtimeConfigService = inject(RuntimeConfigService);

  readonly SOURCE_VERSION = this.runtimeConfigService.SOURCE_VERSION;
  readonly BUILD_ID = this.runtimeConfigService.BUILD_ID;
  readonly ENVIRONMENT_KEY = this.runtimeConfigService.ENVIRONMENT_KEY;

  readonly showEnvironmentIndicator =
    this.runtimeConfigService.ENVIRONMENT_KEY === 'development' ||
    this.runtimeConfigService.ENVIRONMENT_KEY === 'test' ||
    this.runtimeConfigService.ENVIRONMENT_KEY === 'acceptance';

  readonly backgroundColor =
    {
      development: 'red',
      test: 'blue',
      acceptance: 'yellow',
    }[this.runtimeConfigService.ENVIRONMENT_KEY || ''] || 'transparent';
}
